import { render } from "./ShortTextRenderer.vue?vue&type=template&id=b973ec30&scoped=true"
const script = {}

import "./ShortTextRenderer.vue?vue&type=style&index=0&id=b973ec30&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b973ec30"]])

export default __exports__